import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DatePipe } from '@angular/common';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { LoadingInterceptor } from './loading.interceptor.spec';
import { SessiontimerserviceService } from './Session servive/sessiontimerservice.service';
import { GlobalImportsModule } from './global-imports-module';





@NgModule({
declarations:[AppComponent],
imports:[BrowserModule,AppRoutingModule,RouterModule,BrowserAnimationsModule,ToastrModule.forRoot(),NgMultiSelectDropDownModule.forRoot(),GlobalImportsModule],
providers:[provideAnimationsAsync(),{ provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },SessiontimerserviceService,DatePipe],
bootstrap:[AppComponent],
schemas:[CUSTOM_ELEMENTS_SCHEMA]
})

export class AppModule { }